(function(APP, $, window, document) {
	'use strict';

	function Search(options) {
		if (!(this instanceof Search)) return new Search(options);

		var $form = $('.js-search-form');

		$form.on('submit', function(event) {
			event.preventDefault();

			var value = $(this).find('input[name="search"]').val();
			window.location.replace('/formation#term:' + encodeURIComponent(value));

			return false;
		});

		return this;
	}

	$(window).on('load', function() {
		APP.store.search = new Search();
	});

})(APP, jQuery, window, document);
